import styled from "styled-components"

export const WidgetContainer = styled.div`
  position: relative;
  overflow-y: auto;
  height: 100%;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ItemContainer = styled.div`
  border: ${({ primaryActionColor }) => `1px solid ${primaryActionColor}`};
  background-color: #fff;
  margin: 0 0 20px 0;
  padding: 10px;
  height: max-content;
  width: 100%;

  .reference {
    color: ${({ primaryActionColor }) => primaryActionColor || "#787878"};
    margin: 0 0 10px 0;
    font-weight: 600;
  }

  .phase {
    color: red;
    margin: 5px 0 0 0;
  }
`
